// ─── CONFIG ─────────────────────────────────────────────────────────────────
// Altere estas variáveis para conectar à sua infraestrutura real

export const CONFIG = {
  // Evolution API
  EVOLUTION_BASE: 'https://evo.perpe.pro',
  EVOLUTION_KEY: 'SUA_API_KEY_AQUI',

  // n8n
  N8N_BASE: 'http://localhost:5678',
  N8N_API_KEY: 'SUA_N8N_KEY_AQUI',
  // IDs dos workflows (pegar em n8n > Settings > Workflow ID)
  WORKFLOW_DISPARADOR_TEXTO: 'ID_WORKFLOW_DISPARADOR_TEXTO',
  WORKFLOW_DISPARADOR_MIDIA: 'ID_WORKFLOW_DISPARADOR_MIDIA',
  WORKFLOW_SDR_WEBHOOK: 'a669dd00-d22e-4782-85c7-27bc2d58ee87', // path do webhook do SDR

  // Redis (para toggle do agente) — via n8n HTTP ou direto
  REDIS_TOGGLE_WEBHOOK: 'http://localhost:5678/webhook/toggle-agent',

  // Google Sheets (IDs das planilhas por empresa/campanha)
  // Adicionar conforme necessário
};

// ─── EMPRESAS ───────────────────────────────────────────────────────────────
export const INITIAL_COMPANIES = [
  { id: 'perpetue', name: 'Perpetue Digital', color: '#6366f1' },
  { id: 'ioa', name: 'IOA Palmas', color: '#ec4899' },
];

// ─── INSTÂNCIAS EVOLUTION (chips WhatsApp) ──────────────────────────────────
export const INITIAL_INSTANCES = [
  { id: 'sofia', name: 'SOFIA_Perpe.AI', company: 'perpetue', channel: 'whatsapp', active: true },
  { id: 'anna', name: 'ioapalmas_ANNA', company: 'ioa', channel: 'whatsapp', active: true },
];

// ─── CONTATOS DEMO ──────────────────────────────────────────────────────────
export const INITIAL_CONTACTS = [
  {
    id: '5547991234567',
    name: 'Lucas Ferreira',
    phone: '5547991234567',
    company: 'perpetue',
    instance: 'sofia',
    channel: 'whatsapp',
    tags: ['lead', 'hot'],
    stage: 'stage 2',
    agentActive: true,
    unread: 2,
    lastMsg: 'Quero saber mais sobre o produto',
    lastTime: '10:32',
  },
  {
    id: '5511987654321',
    name: 'Marina Costa',
    phone: '5511987654321',
    company: 'perpetue',
    instance: 'sofia',
    channel: 'whatsapp',
    tags: ['lead'],
    stage: 'stage 1',
    agentActive: false,
    unread: 1,
    lastMsg: 'Oi! Vi o post de vocês',
    lastTime: '09:58',
  },
  {
    id: '5548965432109',
    name: 'Ana Beatriz',
    phone: '5548965432109',
    company: 'ioa',
    instance: 'anna',
    channel: 'whatsapp',
    tags: ['lead'],
    stage: 'stage 1',
    agentActive: true,
    unread: 0,
    lastMsg: 'Gostaria de saber sobre o HofDay',
    lastTime: 'Seg',
  },
];

// ─── MENSAGENS DEMO ──────────────────────────────────────────────────────────
export const INITIAL_MESSAGES = {
  '5547991234567': [
    { id: 1, from: 'contact', text: 'Oi! Vi que vocês têm soluções de automação. Quero saber mais.', time: '10:28', type: 'text' },
    { id: 2, from: 'agent', text: 'Bot Sofia ativado — respondendo via SDR Agent (Claude Sonnet)', time: '10:28', type: 'system' },
    { id: 3, from: 'bot', text: 'Oi, Lucas. Tudo bem? Uma coisa que noto em clínicas aqui da região: o faturamento cresce quando o movimento está bom, mas trava quando não tem indicação nova chegando. Isso é algo que você sente também?', time: '10:29', type: 'text' },
    { id: 4, from: 'contact', text: 'Sim exatamente isso. O movimento está irregular.', time: '10:30', type: 'text' },
    { id: 5, from: 'bot', text: 'Faz sentido. Quando o crescimento depende de indicação, você fica refém do humor do mês. Qual é o principal gargalo hoje — atrair pacientes novos ou fazer os que já foram voltarem?', time: '10:31', type: 'text' },
    { id: 6, from: 'contact', text: 'Quero saber mais sobre o produto', time: '10:32', type: 'text' },
  ],
  '5511987654321': [
    { id: 1, from: 'contact', text: 'Oi! Vi o post de vocês e fiquei interessada', time: '09:55', type: 'text' },
    { id: 2, from: 'me', text: 'Olá Marina! Bem-vinda. Me conta mais sobre sua clínica.', time: '09:57', type: 'text' },
    { id: 3, from: 'contact', text: 'Tenho uma clínica estética e estou sobrecarregada', time: '09:58', type: 'text' },
  ],
  '5548965432109': [
    { id: 1, from: 'agent', text: 'Bot Anna ativado — SDR IOA Palmas', time: '09:00', type: 'system' },
    { id: 2, from: 'bot', text: '✨ Ana, que tal cuidar de você com o melhor? A Clínica IOA preparou o HofDay com condições especiais em Botox e Preenchimento. Quer agendar a avaliação gratuita?', time: '09:01', type: 'text' },
    { id: 3, from: 'contact', text: 'Gostaria de saber sobre o HofDay', time: '09:30', type: 'text' },
  ],
};

// ─── ETIQUETAS ───────────────────────────────────────────────────────────────
export const TAG_COLORS = {
  lead: { bg: '#fef3c7', text: '#92400e' },
  hot: { bg: '#fee2e2', text: '#991b1b' },
  client: { bg: '#dcfce7', text: '#166534' },
  support: { bg: '#e0e7ff', text: '#3730a3' },
  cold: { bg: '#f1f5f9', text: '#475569' },
};

export const ALL_TAGS = ['lead', 'hot', 'client', 'support', 'cold'];

// ─── RESPOSTAS RÁPIDAS ───────────────────────────────────────────────────────
export const QUICK_REPLIES = [
  { id: 1, title: 'Saudação', text: 'Olá! Tudo bem? Em que posso te ajudar hoje? 😊' },
  { id: 2, title: 'Aguardar', text: 'Aguarde um momento, vou verificar para você!' },
  { id: 3, title: 'Encerramento', text: 'Obrigado pelo contato! Estamos à disposição.' },
  { id: 4, title: 'Transferência', text: 'Vou te conectar com um especialista agora.' },
  { id: 5, title: 'Avaliação gratuita', text: 'Temos avaliação gratuita e sem compromisso. Posso te mostrar os horários disponíveis?' },
];
